import PropTypes from 'prop-types'
import { compose, pure, setDisplayName } from 'recompose'

import { withComponentDidUpdate } from 'hoc/withComponentDidUpdate'

export const RepositionDropdown = compose(
  setDisplayName('RepositionDropdown'),
  pure,
  withComponentDidUpdate(nextProps => {
    // Schedule rendering update if we expect that dropdown should be repositioned
    nextProps.scheduleUpdate()
  }),
)(() => null)

RepositionDropdown.propTypes = {
  scheduleUpdate: PropTypes.func.isRequired,
}
